module.exports = __webpack_public_path__ + "img/dl (5).95f545fc.jpg";